/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Offer_DismissInputs */

const en_us2_share_offer_dismiss = /** @type {(inputs: Share_Offer_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not now`)
};

const pt_br2_share_offer_dismiss = /** @type {(inputs: Share_Offer_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agora não`)
};

const es_419_share_offer_dismiss = /** @type {(inputs: Share_Offer_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahora no`)
};

const pt_pt2_share_offer_dismiss = /** @type {(inputs: Share_Offer_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agora não`)
};

const fr_fr2_share_offer_dismiss = /** @type {(inputs: Share_Offer_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus tard`)
};

const de_de2_share_offer_dismiss = /** @type {(inputs: Share_Offer_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht jetzt`)
};

const it_it2_share_offer_dismiss = /** @type {(inputs: Share_Offer_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non ora`)
};

/**
* | output |
* | --- |
* | "Not now" |
*
* @param {Share_Offer_DismissInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_offer_dismiss = /** @type {((inputs?: Share_Offer_DismissInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Offer_DismissInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_offer_dismiss(inputs)
	if (locale === "es-419") return es_419_share_offer_dismiss(inputs)
	if (locale === "pt-PT") return pt_pt2_share_offer_dismiss(inputs)
	if (locale === "fr-FR") return fr_fr2_share_offer_dismiss(inputs)
	if (locale === "de-DE") return de_de2_share_offer_dismiss(inputs)
	if (locale === "it-IT") return it_it2_share_offer_dismiss(inputs)
	return en_us2_share_offer_dismiss(inputs)
});
export { share_offer_dismiss as "share.offer_dismiss" }